import { useEffect, useLayoutEffect } from 'react';
import { isBrowser } from './misc/util';
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
export default useIsomorphicLayoutEffect;



//////////////////
// WEBPACK FOOTER
// ./~/react-use/esm/useIsomorphicLayoutEffect.js
// module id = 118
// module chunks = 2